import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../../hooks/searchParamHooks';
import UsageTracker from '../../../utils/UsageTracker';
import { Select } from 'foundations-components/transitional/components/Select';
import { FilterButton } from './FilterButton';
import { useIsPartnerSearchPage } from '../../search/searchHooks';
import { useHasGate, useHasPortalScope } from '../../accounts/accountsQueries';
import PortalIdParser from 'PortalIdParser';
import { useSearch } from '../../search/hooks/useSearch';
import { DownCaratIcon } from 'foundations-assets/icons/components/DownCaratIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const ButtonContent = ({
  value
}) => {
  if (value === 'ACADEMY') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyComponents.topFilters.contentSource.filterTitleWithValue",
      options: {
        value: I18n.text('academyComponents.topFilters.contentSource.ACADEMY')
      }
    });
  }
  if (value === 'CUSTOM_CONTENT') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyComponents.topFilters.contentSource.filterTitleWithValue",
      options: {
        value: I18n.text('academyComponents.topFilters.contentSource.CUSTOM_CONTENT')
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyComponents.topFilters.contentSource.filterTitle"
  });
};
export const useShowContentSourceFilter = () => {
  const portalId = PortalIdParser.getPortalIdFromPath();
  const {
    hasGate
  } = useHasGate('Academy:TrainerContent');
  const {
    hasPortalScope,
    portalScopesError
  } = useHasPortalScope(portalId, 'academy-studio-lms-content-write');
  const shouldCheckFallback = hasGate && portalScopesError;
  const {
    searchResults,
    searchResultsLoading
  } = useSearch({
    variables: {
      pageLength: 1,
      shouldFilterDeprecated: true,
      offset: {
        cursor: 0
      },
      visibilityGroup: 'CUSTOM_CONTENT'
    },
    skip: !shouldCheckFallback
  });
  if (!hasGate) {
    return false;
  }
  if (hasPortalScope === undefined) {
    return false;
  }
  if (hasPortalScope) {
    return true;
  }
  if (portalScopesError && !searchResultsLoading) {
    return !!(searchResults !== null && searchResults !== void 0 && searchResults.length);
  }
  return false;
};
export const DropdownContentSourceFilter = ({
  appearsIn
}) => {
  const canShowContentSourceFilter = useShowContentSourceFilter();
  const isPartnerSearchPage = useIsPartnerSearchPage();
  const [[contentSource], setContentSource] = useSearchParam(FILTER_TYPES.CONTENT_SOURCE);
  if (!canShowContentSourceFilter || isPartnerSearchPage) return null;
  const handleContentSourceChange = value => {
    UsageTracker.trackStandalone('Filter Interaction', {
      action: value ? 'filter-selected' : 'filter-deselected',
      value,
      key: 'content-source-filter',
      appearsIn,
      isDropdown: true
    });
    setContentSource(value);
  };
  return /*#__PURE__*/_jsx(FilterButton, {
    isFilterActive: !!contentSource,
    onClear: () => handleContentSourceChange(null),
    testId: "remove-content-source-filter",
    children: /*#__PURE__*/_jsx(Select, {
      ButtonContent: ButtonContent,
      anchorType: "button",
      buttonContentProps: {
        value: contentSource
      },
      buttonUse: "transparent",
      caretRenderer: () => /*#__PURE__*/_jsx(DownCaratIcon, {
        color: "icon-interactive-default",
        size: "100"
      }),
      "data-test-id": "filter-type-contentSource",
      menuWidth: 200,
      onChange: evt => handleContentSourceChange(evt.target.value),
      options: [{
        text: I18n.text('academyComponents.topFilters.contentSource.ACADEMY'),
        value: 'ACADEMY'
      }, {
        text: I18n.text('academyComponents.topFilters.contentSource.CUSTOM_CONTENT'),
        value: 'CUSTOM_CONTENT',
        help: I18n.text('academyComponents.topFilters.contentSource.customContentHelpText')
      }],
      value: contentSource
    })
  });
};